<template>
  <div class="skdzd-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="收款日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                style="width:300px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="收款性质">
              <el-select v-model="searchForm.nature" style="width: 130px" clearable>
                <el-option
                  v-for="item in receiptNatureList"
                  :key="item.rntid"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收款类型">
              <el-select v-model="searchForm.type" style="width: 130px" clearable>
                <el-option label="订单收款" :value="0"></el-option>
                <el-option label="招商收款" :value="1"></el-option>
                <el-option label="报备金" :value="2"></el-option>
                <el-option label="物料收款" :value="4"></el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="收款账户">
              <el-select v-model="searchForm.aid" style="width:300px" placeholder="请选择" clearable filterable>
                <el-option-group
                  v-for="gitem in groupList"
                  v-if="gitem.nature===0"
                  :key="gitem.groupid"
                  :label="gitem.account_name"
                >
                  <el-option
                    v-for="item in accountsList"
                    v-if="item.groupid===gitem.groupid"
                    :key="item.aid"
                    :label="item.name+'（'+item.card+'）'"
                    :value="item.aid"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" style="width:200px" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search()">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="pringLoading" @click="Print">打印对账单</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="tableData"
              stripe
              :row-style="{cursor: 'pointer'}"
              style="width: 100%"
              @row-click="openDetails"
            >
              <el-table-column
                label="收款日期"
                width="140"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.receipttime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="经销商"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.delname }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单/物料单"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ordernum!==null&&scope.row.ordernum!==''&&scope.row.ordernum!==undefined">{{ scope.row.ordernum }}</span>
                  <span v-if="scope.row.manum!==null&&scope.row.manum!==''&&scope.row.manum!==undefined">{{ scope.row.manum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="生产单号"
                width="120"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ordernum!==null&&scope.row.ordernum!==''&&scope.row.ordernum!==undefined&&scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined" style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                  <span v-if="scope.row.manum!==null&&scope.row.manum!==''&&scope.row.manum!==undefined" style="color:#99a9bf">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收款内容"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.paycontent }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收款性质"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.nature }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收款类型"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.type===0">订单收款</span>
                  <span v-if="scope.row.type===1">招商收款</span>
                  <span v-if="scope.row.type===2">报备金</span>
                  <span v-if="scope.row.type===4">物料收款</span>
                  <span v-if="scope.row.type===9">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收款账户"
                width="140"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.accountname }}/{{ scope.row.accountcard }}
                </template>
              </el-table-column>
              <el-table-column
                label="卡号"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.card!==null&&scope.row.card!==''&&scope.row.card!==undefined">{{ scope.row.card }}</span>
                  <span v-if="scope.row.card===null||scope.row.card===''||scope.row.card===undefined">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                min-width="200"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.remark!==null&&scope.row.remark!==''&&scope.row.remark!==undefined">{{ scope.row.remark }}</span>
                  <span v-if="scope.row.remark===null||scope.row.remark===''||scope.row.remark===undefined">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收款流水号"
                width="210"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.ranum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收款金额"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#409EFF;font-weight: 500;">{{ scope.row.money }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="负责人"
                width="130"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.username }}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="收款详情"
      :visible.sync="receiptApplyVisible"
      width="700px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div v-if="iswlsq===false&&isoffer===true" v-loading="infoloading" style="font-size: 13px;color:#606266;padding: 0 20px;margin-bottom: 20px">
        <div v-if="afterInfo!==null&&afterInfo!==undefined" style="margin-bottom: 15px">
          <span style="color:#99a9bf">售后处理人：</span>
          <span>{{ afterInfo.treat_user }}</span>
          <span style="color:#99a9bf;margin-left: 20px">处理时间：</span>
          <span>{{ afterInfo.treat_time }}</span>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">售后返修单：</span>
            <span class="tcf-link" @click="downFile(afterInfo.fileid)"><i class="el-icon-download" /> {{ afterInfo.file_name }}</span>
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">售后判定单：</span>
            <el-image
              style="width: 60px; height: 60px;"
              fit="cover"
              :preview-src-list="[afterInfo.img_url]"
              :src="afterInfo.img_url"
            />
          </div>
          <div v-if="afterInfo.remark!==null&&afterInfo.remark!==''&&afterInfo.remark!==undefined" style="margin-top: 15px">
            <span style="color:#99a9bf">售后备注：</span>
            <span>{{ afterInfo.remark }}</span>
          </div>
        </div>
        <div>
          <span style="color:#99a9bf">报价员：</span>
          <span>{{ offerInfo.offername }}</span>
          <span style="color:#99a9bf;margin-left: 20px">报价时间：</span>
          <span>{{ offerInfo.offertime }}</span>
        </div>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">报价单：</span>
          <span class="tcf-link" @click="downFile(offerInfo.fileid)"><i class="el-icon-download" /> {{ offerInfo.file_name }}.{{ offerInfo.file_ext }}</span>
        </div>
        <div style="margin-top: 15px">
          <template>
            <el-table
              size="mini"
              :data="orderquotedata"
              style="width: 100%"
            >
              <el-table-column
                align="center"
                prop="year"
                label="年份"
                width="60"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                label="报价书编号"
                mini-width="280"
              >
              </el-table-column>
            </el-table>
          </template>
        </div>
        <el-card shadow="hover" style="margin-top: 15px">
          <div>
            <span style="color:#99a9bf">墙板：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.wall }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">柜体：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.cabinet }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">门类：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.door }}</span>元
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf;">铝材：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.aluminum }}</span>元
            <span style="color:#99a9bf;margin-left: 20px;">配件：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px;">{{ offerInfo.access }}</span>元
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">加价：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.raise }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">优惠：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.best }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">折扣：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.discount }}</span>折
          </div>
        </el-card>
        <el-card v-if="offerAccountReceipt.length>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">折扣/优惠</span>
          <el-table
            :data="offerAccountReceipt"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              show-overflow-tooltip
              label="折扣/优惠名称"
              min-width="120"
            />
            <el-table-column
              width="120"
              align="right"
              show-overflow-tooltip
              label="优惠金额"
            >
              <template slot-scope="scope">
                <span style="color:#F56C6C;margin-right: 6px">{{ scope.row.money }}</span>元
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card v-if="offerInfo.other>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">其他费用：</span>
          <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.other }}</span>元
          <el-table
            :data="offerOther"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              show-overflow-tooltip
              label="费用名称"
              min-width="120"
            />
            <el-table-column
              width="120"
              align="right"
              show-overflow-tooltip
              label="金额"
            >
              <template slot-scope="scope">
                <span style="color:#F56C6C;margin-right: 6px">{{ scope.row.amount }}</span>元
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card v-if="offerInfo.changes>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">更改单费用：</span>
          <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.changes }}</span>元
          <el-table
            :data="offerChanges"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="num"
              label="更改单号"
              width="200"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.type===0" :disable-transitions="true" size="mini" style="margin-right: 6px" type="danger">设计变更</el-tag>
                <el-tag v-if="scope.row.type===1" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-4">材质变更</el-tag>
                <el-tag v-if="scope.row.type===2" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-6">暂停生产</el-tag>
                <el-tag v-if="scope.row.type===3" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-7">取消订单</el-tag>
                <el-tag v-if="scope.row.type===4" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-2">颜色变更</el-tag>
                <el-tag v-if="scope.row.type===5" :disable-transitions="true" size="mini" style="margin-right: 6px" type="warning">通知单</el-tag>
                <el-tag v-if="scope.row.type===6" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-10">其他</el-tag>
                {{ scope.row.num }}
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="变更内容"
              min-width="200"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              label="更改费用"
              width="100"
              fixed="right"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span style="color:#f56c6c">{{ scope.row.amount }}</span>元
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="100"
              fixed="right"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-search" size="mini" @click="viewOrderChange(scope.row)">详细</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">总报价：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.amount }}</span>元
          <s v-if="offerInfo.amount!==offerInfo.totalprice" style="margin-left: 10px;color:#999;">{{ offerInfo.totalprice }}</s>
        </div>
        <div v-if="offerInfo.factorycom>0||offerInfo.designcom>0" style="margin-top: 15px">
          <span style="color:#99a9bf">设计承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.designcom }}</span>元
          <span style="color:#99a9bf;margin-left: 20px">工厂承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.factorycom }}</span>元
          <span style="color:#99a9bf;margin-left: 20px">客户承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.clientcom }}</span>元
        </div>
        <div v-if="offerImgs!==null&&offerImgs!==undefined&&offerImgs.length>0" style="margin-top: 15px">
          <span style="color:#99a9bf">领导凭证：</span>
          <el-image
            v-for="img in offerImgs"
            style="width: 50px; height: 50px;margin-right: 10px"
            :src="img"
            :preview-src-list="offerImgs"
            fit="cover"
          />
        </div>
        <div v-if="offerInfo.remark!==null&&offerInfo.remark!==''&&offerInfo.remark!==undefined" style="margin-top: 15px">
          <span style="color:#99a9bf">备注：</span>
          <span>{{ offerInfo.remark }}</span>
        </div>
      </div>
      <table v-loading="receiptApplyLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ receiptApplyData.applyname }}</td>
          <th>申请时间</th>
          <td>{{ receiptApplyData.time }}</td>
        </tr>
        <tr>
          <th>流水号</th>
          <td>{{ receiptApplyData.ranum }}</td>
          <th v-if="receiptApplyData.orderid!==null&&receiptApplyData.orderid!==''&&receiptApplyData.orderid!==undefined">订单号</th>
          <td v-if="receiptApplyData.orderid!==null&&receiptApplyData.orderid!==''&&receiptApplyData.orderid!==undefined"><span style="color:#409EFF;cursor: pointer" @click="goOrder(receiptApplyData.orderid)"><i class="el-icon-document"></i> {{ receiptApplyData.ordernum }}</span></td>
          <th v-if="receiptApplyData.maid!==null&&receiptApplyData.maid!==''&&receiptApplyData.maid!==undefined">物料单号</th>
          <td v-if="receiptApplyData.maid!==null&&receiptApplyData.maid!==''&&receiptApplyData.maid!==undefined">{{ receiptApplyData.manum }}</td>
        </tr>
        <tr v-if="receiptApplyData.orderid!==null&&receiptApplyData.orderid!==''&&receiptApplyData.orderid!==undefined">
          <th>终端地址</th>
          <td>{{ receiptApplyData.address }}</td>
          <th>生产单号</th>
          <td>{{ receiptApplyData.produnum }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ receiptApplyData.dealerName }}</td>
          <th>卡号</th>
          <td>{{ receiptApplyData.card }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">{{ receiptApplyData.accountname }}（{{ receiptApplyData.accountcard }}）</td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ receiptApplyData.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ receiptApplyData.nature }}</td>
        </tr>
        <tr>
          <th>打款内容</th>
          <td>{{ receiptApplyData.paycontent }}</td>
          <th>打款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ receiptApplyData.money }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in imgReceiptApplySrcList"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgReceiptApplySrcList"
            >
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ receiptApplyData.remark }}</td>
        </tr>
        <tr v-if="receiptApplyData.mark===2||receiptApplyData.mark===1">
          <th>审核人</th>
          <td>{{ receiptApplyData.auditname }}</td>
          <th>审核时间</th>
          <td>{{ receiptApplyData.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="receiptApplyVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="招商收款详情"
      :visible.sync="viewClientVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewClientLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewClientData.apply_name }}</td>
          <th>申请时间</th>
          <td>{{ viewClientData.time }}</td>
        </tr>
        <tr>
          <th>客户</th>
          <td>{{ viewClientData.all_name }}</td>
          <th>卡号</th>
          <td>{{ viewClientData.card_num }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">{{ viewClientData.accountname }}（{{ viewClientData.accountcard }}）</td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ viewClientData.pay_time }}</td>
          <th>打款金额</th>
          <td>{{ viewClientData.pay_price }}（样品预存款：{{ viewClientData.joins }}，加盟费：{{ viewClientData.insure }}）</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in imgClientSrcList"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgClientSrcList"
            >
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ viewClientData.remark }}</td>
        </tr>
        <tr>
          <th>审核人</th>
          <td>{{ viewClientData.auditname }}</td>
          <th>审核时间</th>
          <td>{{ viewClientData.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewClientVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="报备金详情"
      :visible.sync="viewReportVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewReportLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewReportdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewReportdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewReportdata.delname }}</td>
          <th style="width: 100px">报备金名称</th>
          <td colspan="3" style="color:#000;">{{ viewReportdata.name }}</td>
        </tr>
        <tr>
          <th>报备要求</th>
          <td>
            {{ viewReportdata.per }}/单
          </td>
          <td colspan="4">
            同比享受最低折扣不低于 {{ viewReportdata.mindiscount }} 折
          </td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportAddress">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.address }}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span><i class="el-icon-date"></i> {{ viewReportdata.starttime }} ~ {{ viewReportdata.endtime }}</span>
          </td>
        </tr>
        <tr>
          <th>对应折扣</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportDiscount">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.starttime }} 至 {{ d.endtime }}</td>
                <td style="width: 100px;text-align: center">{{ d.discount }}折</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="5">{{ viewReportAcccount.groupname }}（{{ viewReportAcccount.name }}，{{ viewReportAcccount.card }}）</td>
        </tr>
        <tr>
          <th>打款金额</th>
          <td style="font-weight: 500;color:#409EFF;"><i class="el-icon-coin"></i> {{ viewReportdata.amount }}</td>
          <th>打款日期</th>
          <td>{{ viewReportdata.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ viewReportdata.nature }}</td>
        </tr>
        <tr>
          <th>报备凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgReportSrcList"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgReportSrcList"
            >
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewReportdata.remark }}</td>
        </tr>
        <tr v-if="viewReportdata.mark===2">
          <th>审核人</th>
          <td>{{ viewReportdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewReportdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewReportVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="viewOrderChangeTitle"
      :visible.sync="viewOrderChangeVisible"
      width="1120px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-row v-loading="viewOrderChangeLoading">
        <el-col :span="10">
          <table class="tcf-detail-table">
            <tr>
              <th>更改单号</th>
              <td>{{ viewOrderChangeData.oc.num }}</td>
              <th>生产单号</th>
              <td>{{ viewOrderChangeData.oc.produnum }}</td>
            </tr>
            <tr>
              <th>详细地址</th>
              <td colspan="3">{{ viewOrderChangeData.oc.address }}</td>
            </tr>
            <tr>
              <th>变更类别</th>
              <td>
                <span v-if="viewOrderChangeData.oc.type===0">设计变更</span>
                <span v-if="viewOrderChangeData.oc.type===1">材质变更</span>
                <span v-if="viewOrderChangeData.oc.type===2">暂停生产</span>
                <span v-if="viewOrderChangeData.oc.type===3">取消订单</span>
                <span v-if="viewOrderChangeData.oc.type===4">颜色变更</span>
                <span v-if="viewOrderChangeData.oc.type===5">通知单</span>
                <span v-if="viewOrderChangeData.oc.type===6">其他</span>
              </td>
              <th>申请部门</th>
              <td>
                <span v-if="viewOrderChangeData.oc.dept===0">客户</span>
                <span v-if="viewOrderChangeData.oc.dept===1">拆单</span>
                <span v-if="viewOrderChangeData.oc.dept===2">方案</span>
                <span v-if="viewOrderChangeData.oc.dept===3">车间</span>
                <span v-if="viewOrderChangeData.oc.dept===4">采购</span>
                <span v-if="viewOrderChangeData.oc.dept===5">软件</span>
                <span v-if="viewOrderChangeData.oc.dept===6">其他</span>
                <span v-if="viewOrderChangeData.oc.dept===7">建模</span>
                <span v-if="viewOrderChangeData.oc.dept===8">研发</span>
              </td>
            </tr>
            <tr>
              <th>变更内容</th>
              <td colspan="3"><div class="pl">{{ viewOrderChangeData.oc.content }}</div></td>
            </tr>
            <tr>
              <th>拆单人员</th>
              <td>{{ viewOrderChangeData.oc.splitname }}</td>
              <th>生产动态</th>
              <td style="font-weight: bold;color:#f56c6c">
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===0">PMC阶段</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===1">开料完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===2">组装完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===3">贴皮完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===4">白胚完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===5">做灰完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===6">底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===7">粗磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===8">二次底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===9">细磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===10">面漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===11">包装完工</span>
              </td>
            </tr>
            <tr>
              <th>变更原因</th>
              <td colspan="3">{{ viewOrderChangeData.oc.rson }}</td>
            </tr>
            <tr>
              <th colspan="2" style="text-align: center">变更前内容</th>
              <th colspan="2" style="text-align: center">变更后内容</th>
            </tr>
            <tr>
              <td colspan="2"><div class="pl">{{ viewOrderChangeData.oc.beforetxt }}</div></td>
              <td colspan="2"><div class="pl">{{ viewOrderChangeData.oc.aftertxt }}</div></td>
            </tr>
            <tr v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">
              <th>报价明细</th>
              <td colspan="3">{{ viewOrderChangeData.oc.offerdetail }}</td>
            </tr>
            <tr v-if="viewOrderChangeData.oc.mark>4">
              <th v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">报价费用</th>
              <td v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4" style="font-weight: bold;color:#409EFF">{{ viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.amount:'' }}</td>
              <th>交期延长</th>
              <td :colspan="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4?1:3">{{ viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.day+'天':'' }}</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="5">
          <el-timeline>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>0?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>0?viewOrderChangeData.oc.time:''"
            >
              提交
              <div v-if="viewOrderChangeData.oc.mark>0" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.initname }}<el-tag size="mini" :type="viewOrderChangeData.oc.inittype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.initposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>1?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>1?viewOrderChangeData.oc.sercontime:''"
            >
              客服确认
              <div v-if="viewOrderChangeData.oc.mark>1" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.servicename }}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.serviceposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>2?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>2?viewOrderChangeData.oc.pmctime:''"
            >
              生产动态
              <div v-if="viewOrderChangeData.oc.mark>2" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.pmcuname }}<el-tag size="mini" type="warning" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcuposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>3?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>3?viewOrderChangeData.oc.assesstime:''"
            >
              设计确认
              <div v-if="viewOrderChangeData.oc.mark>3" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.assessname }}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.assessposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=4||viewOrderChangeData.oc.offerid!==0"
              :type="viewOrderChangeData.oc.mark>4?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.offertime:''"
            >
              更改单报价
              <div v-if="viewOrderChangeData.oc.mark>4" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.offername }}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.offerposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=5||viewOrderChangeData.oc.conid!==0"
              :type="viewOrderChangeData.oc.mark>5?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>5?viewOrderChangeData.oc.contime:''"
            >
              客户确认
              <div v-if="viewOrderChangeData.oc.mark>5" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.conname }}<el-tag size="mini" :type="viewOrderChangeData.oc.contype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.conposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>6?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.pmccontime:''"
            >
              PMC确认
              <div v-if="viewOrderChangeData.oc.mark>6" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.pmcconname }}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcconposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark===100?'primary':''"
            >
              完成
            </el-timeline-item>
          </el-timeline>
        </el-col>
        <el-col :span="9" class="tcf-order-change-remark">
          <div class="title">
            <span>更改单备注</span>
          </div>
          <div v-if="viewOrderChangeData.ocrlst.length===0" class="order-dynamic-not">
            暂无更改单备注数据
          </div>
          <div class="content-list">
            <div v-for="d in viewOrderChangeData.ocrlst" class="order-dynamic-item">
              <div class="photo">
                <el-avatar shape="square" :size="50" :src="d.photo" />
              </div>
              <div class="info">
                <div class="username"><span>{{ d.username }}</span><el-tag v-if="d.posname!==null&&d.posname!==''&&d.posname!==undefined" :type="d.color===0?'':d.color===1?'success':d.color===2?'warning':''" size="mini">{{ d.posname }}</el-tag></div>
                <div class="time"><i class="el-icon-time" /> {{ d.time }}</div>
                <div class="content">
                  <div v-if="d.ispub===1" style="color:#f56c6c;"><i class="el-icon-lock"></i> 仅组织员工可见，经销商无法查看</div>
                  <el-tag v-if="d.ctype===1" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客服确认驳回</el-tag>
                  <el-tag v-if="d.ctype===2" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">生产动态驳回</el-tag>
                  <el-tag v-if="d.ctype===3" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">设计确认驳回</el-tag>
                  <el-tag v-if="d.ctype===4" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">报价驳回</el-tag>
                  <el-tag v-if="d.ctype===5" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客户确认驳回</el-tag>
                  <el-tag v-if="d.ctype===6" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">PMC确认驳回</el-tag>
                  {{ d.content }}
                </div>
                <div class="files">
                  <div v-for="f in d.filelst" class="file-item" @click="downFile(f.fileid)">
                    <i class="el-icon-document" />
                    <div class="file-name">{{ f.file_name }}.{{ f.file_type }}</div>
                  </div>
                </div>
                <div class="imgs">
                  <el-image
                    v-for="img in d.imglst"
                    fit="cover"
                    class="dynamic-img"
                    :src="img"
                    :preview-src-list="d.imglst"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getAccounts, getGroupReport, getFileInfo } from '@/api/pub'
import {
  getReceiptNature,
  getReceiptStatementList,
  printReceiptStatement,
  getReceiptApplyByRaid,
  getDealerAccountReportById,
  getOrderNuclearPriceDetail,
  getOrderChangeDetail
} from '@/api/erp'
import { getMerchantsMoneyDetail } from '@/api/work'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'Skdzd',
  data() {
    return {
      groupList: [],
      accountsList: [],
      receiptNatureList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        time: [],
        aid: null,
        nature: null,
        type: null
      },
      tableData: [],
      loading: false,
      pringLoading: false,
      receiptApplyVisible: false,
      receiptApplyLoading: false,
      receiptApplyData: [],
      imgReceiptApplySrcList: [],
      viewClientVisible: false,
      imgClientSrcList: [],
      viewClientLoading: false,
      viewClientData: [],
      viewReportVisible: false,
      viewReportLoading: false,
      viewReportdata: [],
      imgReportSrcList: [],
      viewReportAddress: [],
      viewReportDiscount: [],
      viewReportAcccount: [],
      infoloading: false,
      offerInfo: [],
      offerImgs: [],
      offerOther: [],
      offerAccountReceipt: [],
      afterInfo: null,
      iswlsq: false,
      isoffer: false,
      offerChanges: [],
      viewOrderChangeTitle: '',
      viewOrderChangeVisible: false,
      viewOrderChangeLoading: false,
      viewOrderChangeData: {
        oc: [],
        ocrlst: []
      },
      orderquotedata: []
    }
  },
  computed: {
    user: getUser
  },
  created() {
    getGroupReport().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
    getReceiptNature().then(response => {
      this.receiptNatureList = response.data
    }).catch(() => {})
    this.getData()
  },
  methods: {
    viewOrderChange(row) {
      if (!this.viewOrderChangeVisible) {
        this.viewOrderChangeTitle = `更改单 ${row.num} 详情`
        this.viewOrderChangeVisible = true
      }
      this.viewOrderChangeLoading = true
      getOrderChangeDetail({ ocid: row.ocid, role: 1 }).then(response => {
        this.viewOrderChangeLoading = false
        this.viewOrderChangeData = response.data
      }).catch(() => {
        this.viewOrderChangeLoading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      this.loading = true
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
        if (this.searchForm.time.length === 2) {
          starttime = this.searchForm.time[0]
          endtime = this.searchForm.time[1]
        }
      }
      const data = {
        aid: this.searchForm.aid,
        nature: this.searchForm.nature,
        type: this.searchForm.type,
        content: this.searchForm.search,
        starttime: starttime,
        endtime: endtime,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid
      }
      getReceiptStatementList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    Print() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (!this.pringLoading) {
          let starttime = ''
          let endtime = ''
          if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
            if (this.searchForm.time.length === 2) {
              starttime = this.searchForm.time[0]
              endtime = this.searchForm.time[1]
            }
          }
          if (this.total > 400) {
            if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
              if (this.searchForm.time.length !== 2) {
                this.$message({
                  message: '由于数据量过多，请选择打款日期区间再打印',
                  type: 'warning'
                })
                return false
              }
            } else {
              this.$message({
                message: '由于数据量过多，请选择打款日期区间再打印',
                type: 'warning'
              })
              return false
            }
          }
          this.pringLoading = true
          const data = {
            aid: this.searchForm.aid,
            nature: this.searchForm.nature,
            type: this.searchForm.type,
            content: this.searchForm.search,
            starttime: starttime,
            endtime: endtime,
            userid: this.user.dUserid
          }
          printReceiptStatement(data).then(response => {
            this.pringLoading = false
            LODOP.PRINT_INIT('收款对账单打印')
            LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A4')
            LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
            LODOP.ADD_PRINT_TABLE(30, 1, '100%', '100%', response.data)
            LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
            LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
            LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
            LODOP.NewPageA()
            LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
            LODOP.PREVIEW()
          }).catch(() => {
            this.pringLoading = false
          })
        }
      }
    },
    goOrder(orderid) {
      this.receiptApplyVisible = false
      this.$router.push({ path: '/work/order/' + orderid })
    },
    downFile(fileid) {
      getFileInfo({ fileid: fileid }).then(response => {
        /* this.$message({
          message: '已下载 ' + response.data.dName + '.' + response.data.dType,
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    openDetails(row) {
      if (row.type === 0 || row.type === 4 || row.type === 9) {
        this.isoffer = false
        if (row.manum !== null && row.manum !== '' && row.manum !== undefined) {
          this.iswlsq = true
        } else {
          this.iswlsq = false
          if (row.orderid !== null && row.orderid !== '' && row.orderid !== undefined) {
            this.isoffer = true
            this.infoloading = true
            this.afterInfo = null
            getOrderNuclearPriceDetail({ orderid: row.orderid }).then(response => {
              this.offerInfo = response.data.offer
              this.offerImgs = this.offerInfo.imglst
              this.offerOther = this.offerInfo.otherlst
              this.offerAccountReceipt = this.offerInfo.dralst
              this.afterInfo = response.data.after
              this.offerChanges = this.offerInfo.changelst
              this.orderquotedata = this.offerInfo.quotes
              this.infoloading = false
            }).catch(() => {
              this.infoloading = false
            })
          }
        }
        this.imgReceiptApplySrcList = []
        this.receiptApplyVisible = true
        this.receiptApplyLoading = true
        getReceiptApplyByRaid({ raid: row.raid }).then(response => {
          this.receiptApplyLoading = false
          this.receiptApplyData = response.data
          const imgs = []
          for (const c of this.receiptApplyData.imglst) {
            imgs.push(c.img_url)
          }
          this.imgReceiptApplySrcList = imgs
        }).catch(() => {
          this.receiptApplyData = []
          this.receiptApplyLoading = false
        })
      } else if (row.type === 1) {
        this.imgClientSrcList = []
        this.viewClientVisible = true
        this.viewClientLoading = true
        getMerchantsMoneyDetail({ payid: row.raid, userid: this.user.dUserid }).then(response => {
          this.viewClientData = response.data
          const imgs = []
          for (const c of this.viewClientData.imgList) {
            imgs.push(c.img_url)
          }
          this.imgClientSrcList = imgs
          this.viewClientLoading = false
        }).catch(() => {
          this.viewClientLoading = false
        })
      } else if (row.type === 2) {
        this.imgReportSrcList = []
        this.viewReportVisible = true
        this.viewReportLoading = true
        getDealerAccountReportById({ darid: row.raid }).then(response => {
          this.viewReportLoading = false
          this.viewReportdata = response.data.dar
          this.viewReportAddress = response.data.daralst
          this.viewReportDiscount = response.data.dardlst
          this.viewReportAcccount = response.data.acccount
          const imgs = []
          for (const c of response.data.imgs) {
            imgs.push(c.img_url)
          }
          this.imgReportSrcList = imgs
        }).catch(() => {
          this.viewReportLoading = false
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
